module.exports = __webpack_public_path__ + "assets/img/00071.2e8f95d2.png";